import { render } from "./SellerPromotions.vue?vue&type=template&id=6b956c4e&scoped=true"
import script from "./SellerPromotions.vue?vue&type=script&lang=js"
export * from "./SellerPromotions.vue?vue&type=script&lang=js"

import "./SellerPromotions.vue?vue&type=style&index=0&id=6b956c4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b956c4e"]])

export default __exports__